import React, { useState, useRef } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { Grid, Button, Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CSVLink } from 'react-csv';
import ApiHelper from '../../utils/apiHelper';

const ReportFileExports = ({ downloadFileName, data, downloadFileOption, headers, filters, setExportLoading }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const csvLink = useRef();
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const downloadCSVDocument = () => {
        csvLink.current.link.click();
        handleClose();
    };

    const downloadSeverSideReportDocument = () => {
        setExportLoading(true);
        ApiHelper.post(`/api/reports/download-report/`, filters, {}, {}, true, 'blob')
            .then((response) => {
                let fileName = 'report.pdf';
                const contentDisposition = response.headers['content-disposition'];
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
                    if (fileNameMatch.length > 1) {
                        fileName = fileNameMatch[1];
                    }
                }
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); // or any other extension
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                handleClose();
                setExportLoading(false);
                toast.success('Successfully done');
            })
            .catch((error) => {
                handleClose();
                toast.error('Error downloading the report');
            });
    };
    const clearString = (jsonData) => {
        const jsonString = JSON.stringify(jsonData);
        console.log(jsonString);
        const clearedJsonString = jsonString.replace(/[^a-zA-Z0-9\s\{\}\[\],:\";]/g, '');
        console.log(clearedJsonString);
        const clearedJson = JSON.parse(clearedJsonString);
        return clearedJson;
    };

    return (
        <Grid sx={{ float: 'right' }}>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
            >
                Export
            </Button>
            {downloadFileOption === 'all' && (
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button'
                    }}
                >
                    {/* <MenuItem onClick={downloadPdfDocument}>Download PDF</MenuItem> */}
                    <MenuItem onClick={downloadSeverSideReportDocument}>Download PDF</MenuItem>
                    <MenuItem onClick={downloadCSVDocument}>Download CSV</MenuItem>
                    {/* <MenuItem onClick={downloadSeverSideReportDocument}>Test</MenuItem> */}
                </Menu>
            )}
            {downloadFileOption === 'csv' && (
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button'
                    }}
                >
                    <MenuItem onClick={downloadCSVDocument}>Download CSV</MenuItem>
                </Menu>
            )}
            {downloadFileOption === 'pdf' && (
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button'
                    }}
                >
                    {/* <MenuItem onClick={downloadPdfDocument}>Download PDF</MenuItem> */}
                    <MenuItem onClick={downloadSeverSideReportDocument}>Download PDF</MenuItem>
                </Menu>
            )}
            <CSVLink
                data={data} /* {clearString(data)} */
                headers={headers}
                filename={`${downloadFileName}.csv`}
                className="hidden"
                ref={csvLink}
                target="_blank"
            />
        </Grid>
    );
};

ReportFileExports.propTypes = {
    elementId: PropTypes.string,
    reportTitle: PropTypes.string,
    downloadFileName: PropTypes.string,
    downloadFileOption: PropTypes.string,
    data: PropTypes.array,
    headers: PropTypes.array,
    filters: PropTypes.object,
    setExportLoading: PropTypes.func
};

export default ReportFileExports;
